/**
 * @Pipe: pipe to countdown remaining chars left to enter in textfield
 * @author: manohar katam
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countdownChars'
})
export class CountdownCharsPipe implements PipeTransform {

  transform(text: string, args: number): number {
    const maxLength = args;

    const length = text.length;

    return (maxLength - length);
  }

}
